import api from '@/common/api';
import { makeResponse } from '@/common/api/utils';


export const completeResearchSession = async (sessionUUID, data) => (
  makeResponse(
    await api.patch(
      `rev/research-review-sessions/${sessionUUID}/complete/`,
      data,
    ),
  )
);

export const fetchResearch = async (researchUUID, isTest) => {
  const params = {};
  if (isTest) {
    params.test = true;
  }
  return makeResponse(await api.get(`rev/researches/${researchUUID}/`, params));
};

export const fetchResearchSet = async (researchSetUUID) => (
  makeResponse(
    await api.get(
      `rev/research-sets/${researchSetUUID}/`,
    ),
  )
);

export const fetchResearchSetOrganisations = async (researchSetUUID) => (
  makeResponse(
    await api.get(
      `public/research-sets/${researchSetUUID}/organisations/`,
    ),
  )
);

export const fetchResearchSetResearches = async (researchSetUUID) => (
  makeResponse(
    await api.get(
      `public/research-sets/${researchSetUUID}/researches/`,
    ),
  )
);

export const fetchResearchSetIdentifier = async (externalSlug, identifierValue) => (
  makeResponse(
    await api.get(
      `external-party/${externalSlug}/research-set-identifier/${identifierValue}/`,
    ),
  )
);


export const fetchExternalParty = async (externalSlug, researchSetIdentifier, userIdentifier) => (
  makeResponse(
    await api.get(
      `external-parties/${externalSlug}/?uid=${userIdentifier}&rsid=${researchSetIdentifier}`,
    ),
  )
);

export const updateResearchAnswer = async (answerId, data) => (
  makeResponse(await api.patch(`rev/research-answers/${answerId}/`, data))
);


export const deleteResearchReviewSession = async (sessionUUID) => (
  makeResponse(await api.delete(`rev/research-review-sessions/${sessionUUID}/`))
);

export const fetchResearchReviewSession = async (sessionUUID) => (
  makeResponse(await api.get(`rev/research-review-sessions/${sessionUUID}/`))
);


// New Namespace (rev);
export const fetchResearchItem = async (researchUUID, researchItemId, sessionUUID) => (
  makeResponse(
    await api.get(
      `rev/researches/${researchUUID}/research-items/${researchItemId}/`,
      { uuid: sessionUUID },
    ),
  )
);

export const fetchResearchReviewSessions = async () => (
  makeResponse(
    await api.get(
      'rev/research-review-sessions/',
    ),
  )
);

// Migrated to new api paths;
export const fetchResearchItems = async (researchSlug, sessionUUID) => (
  makeResponse(
    await api.get(
      `rev/researches/${researchSlug}/research-items/`,
      { uuid: sessionUUID },
    ),
  )
);


export const fetchRelatedResearches = async (researchUUID) => (
  makeResponse(
    await api.get(
      `rev/researches/${researchUUID}/related-researches/`,
    ),
  )
);
